module.exports = __webpack_public_path__ + "img/3-flexibility.a0414992.svg";